export const OFFER_EXPIRED = 'Sorry! The offer is expired.';

export const OFFER_INVALID = 'Sorry! The offer is invalid.';
